"use client";

import {JSX, ReactNode} from "react";

import {Typography} from "@/shared/ui/data-display/typography";

import "@/shared/ui/maps/google-location-map/styles/location-map.scss";

export interface LocationMapLayoutProps {
    title: string;
    location?: ReactNode | string;
    note?: string;
    className?: string;
    showBorder?: boolean;
    borderRadius?: number;
    children: ReactNode;
}

export function LocationMapLayout({
    title,
    location,
    note,
    className = "",
    showBorder = false,
    borderRadius = 8,
    children,
}: LocationMapLayoutProps): JSX.Element {
    return (
        <div className={`location-map ${className}`}>
            <Typography as="h2" size={{desktop: 24, mobile: 20}} weight={600} className="location-map__title">
                {title}
            </Typography>

            {typeof location === "string" ? (
                <Typography as="div" size={{desktop: 16, mobile: 14}} weight={600} className="location-map__location">
                    {location}
                </Typography>
            ) : (
                location
            )}

            <Typography as="div" size={{desktop: 14, mobile: 12}} weight={500} className="location-map__note">
                {note}
            </Typography>

            <div
                className={`location-map__container ${showBorder ? "location-map__container--border" : ""}`}
                style={{borderRadius: `${borderRadius}px`}}
            >
                {children}
            </div>
        </div>
    );
}
